<template>
  <div class="tab-block">
    <div class="tab-header">{{ tabData.categoryName }}</div>
    <div class="tab-list" v-if="tabData.list?.length">
      <div class="tab-item hover-text"
        :class="{ 'tab-active': seccode || code ? item.categoryCode == seccode || item.categoryCode == code : index == 0 }"
        v-for="(item, index) in tabData.list" :key="index" @click="changeTab(item, item.categoryCode)">
        <div class="tab-item-title">
          <div class="title">{{ item.categoryName }}</div>
          <div class="triangle"
            :class="{ 'triangle-active': showExtend && item.categoryCode == seccode && item.list?.length != 0 }">
          </div>
        </div>
        <div class="tab-item-content"
          v-if="showExtend && item.list && item.list.length && item.categoryCode == seccode">
          <div class="tab-item-subtitle tab-subtitle"
            :class="{ 'subtitle-active': code == subcode || subcode ? t.categoryCode == subcode : i == 0 }"
            v-for="(t, i) in item.list" :key="i" @click.stop="changeSubTab(t, item.categoryCode)">
            <div class="title">{{ t.categoryName }}</div>
            <!-- <div class="triangle"></div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["tabData", "code", "seccode", "subcode"],
  data() {
    return {
      isActive: false,
      showExtend: false,
      currentCode : this.code,
    };
  },
  watch: {
    tabData(newV) {
      // console.log("--三级--二级--newV", this.code, this.seccode, newV);
      if (newV && newV.list && newV.list.length > 0){
        const foundItem = newV.list.find(item => item.categoryCode == this.seccode);
        if(foundItem) {
          this.showExtend = foundItem.list?.length > 0;
        }
        // console.log("--三级--二级--subcode", this.code, this.seccode, this.subcode);
      }
    }
},
  created() {},
  methods: {
    //切换栏目
    changeTab(item, tab) {
      // console.log("--三级--二级--changeTab", this.code, this.seccode, this.subcode, this.showExtend);

      // console.log("item111", item, tab, this.showExtend);

      if (!item.list || item.list.length == 0) {
        this.showExtend = false
      } else {
        this.showExtend = !this.showExtend
      }
      this.$emit("changeSecTab", item, tab);
    },
    //切换副栏目
    changeSubTab(item, tab) {
      this.$emit("changeSecTab", item, tab);
    },
  },
};
</script>

<style lang="scss" scoped>
.tab-block {
  display: flex;
  flex-direction: column;
  min-height: 492px;

  .tab-header {
    height: 57px;
    line-height: 1.35em;
    color: #fff;
    font-size: 22px;
    font-weight: bold;
    background: #087cd6;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .tab-list {
    display: flex;
    flex-direction: column;
    font-size: 18px;
    padding: 0 18px 0 16px;

    .tab-item {
      display: flex;
      justify-content: center;
      flex-direction: column;
      border-bottom: 1px dashed #e6e6e6;

      .tab-item-title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        min-height: 51px;
      }

      .title {
        flex: 1;
        display: -webkit-box;
        word-break: break-all;
        text-overflow: ellipsis;
        overflow: hidden;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
      }

      .triangle {
        width: 0;
        height: 0;
        border-top: 7px solid transparent;
        border-bottom: 7px solid transparent;
        border-right: 7px solid black;
        transform: rotate(180deg);
      }

      .tab-item-content {
        color: #000;

        .tab-item-subtitle {
          display: flex;
          align-items: center;
          justify-content: space-between;
          min-height: 51px;
          padding-left: 1em;
        }

        .triangle {
          border-right-color: #000;
        }
      }
    }

    .tab-item:hover {
      .tab-item-title {
        .triangle {
          border-right-color: #087cd6 !important;
        }
      }
    }

    .tab-active {
      .tab-item-title {
        color: #087cd6;

        .triangle {
          border-right-color: #087cd6 !important;
        }
      }
    }

    .tab-subtitle:hover {
      .title {
        color: #087cd6;
      }

      .triangle {
        border-right-color: #087cd6 !important;
      }
    }

    .subtitle-active {
      .title {
        color: #087cd6;
      }

      .triangle {
        border-right-color: #087cd6 !important;
      }
    }

    .triangle-active {
      transform: rotate(270deg) !important;
    }
  }
}
</style>
